module.exports = __webpack_public_path__ + "4ec8b9ec16dbabab45d5aeb24a9b5fdf.jpg";